import React, { useContext } from "react";
import {
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  Typography,
  Tooltip,
} from "@mui/material";
import {
  StyledTableCellHistory,
  StyledTableCellHistoryForPreview,
  StyledTableContainer,
  StyledTableRowHistory,
} from "../StyledComponents";
import { BrandingContext } from "../../../BrandingProvider";
import {
  formatDateIST,
  formatDateTime,
  formatDateYYYYMMDD,
  getHumanReadableDiffInPastDateWithAgo,
  getHumanReadableDurationInDate,
} from "./UtilsFunctions";
import dayjs from "dayjs";
import { ChiefComplaintTable } from "../Sections/ChiefComplaintTable";
import { formatDurationTextForDisplay } from "../HistoriesData/durationUtils";
import DisplayDate from "../../../components/date/DisplayDate";

export const chiefComplaintsData = (selectedSectionsData) => {
  console.log("Chief Complaint Data", selectedSectionsData);
  return (
    // <ul
    //   style={{
    //     listStyleType: "disc",
    //     padding: "0px 0px 0px 20px",
    //   }}
    // >
    //   {selectedSectionsData.length > 0 &&
    //     selectedSectionsData
    //       // .filter((item) => item.onset_datetime) // Filter items with onset_datetime
    //       .map((item, index) => (
    //         <div
    //           key={index}
    //           style={{
    //             display: "flex",
    //             alignItems: "center",
    //             justifyContent: "space-between",
    //           }}
    //         >
    //           <li
    //             style={{
    //               fontWeight: "bold",
    //               color: "black",
    //               padding: "0px",
    //               margin: "5px",
    //               fontSize: "12px",
    //             }}
    //           >
    //             <>
    //               <div>
    //                 {item.condition}
    //                 {/* {item.onset_datetime
    //                   ? ` -Starts From ${item.onset_datetime}`
    //                   : ""} */}
    //               </div>
    //               {item.duration && item.duration.length != 0 && (
    //                 <div>
    //                   Duration - {item.duration} {item.durationType}
    //                 </div>
    //               )}
    //               {item.clinical_status_description.length != 0 && (
    //                 <div>
    //                   Clinical Status - {item.clinical_status_description}
    //                 </div>
    //               )}
    //               {item.clinical_note.length != 0 && (
    //                 <div>Clinical Note - {item.clinical_note}</div>
    //               )}
    //             </>
    //           </li>
    //         </div>
    //       ))}
    // </ul>
    <>
      {selectedSectionsData.length > 0 && (
        <Grid item xs={11}>
          <StyledTableContainer component={Paper}>
            <Table sx={{ minWidth: 500 }}>
              <TableHead>
                <StyledTableRowHistory>
                  <StyledTableCellHistoryForPreview>
                    Condition Name
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Clinical Status
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Duration
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Clinical Notes
                  </StyledTableCellHistoryForPreview>
                </StyledTableRowHistory>
              </TableHead>
              <TableBody>
                {selectedSectionsData.map((row, rowIndex) => (
                  <StyledTableRowHistory key={rowIndex}>
                    <StyledTableCellHistory>
                      {row.condition}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row.clinical_status_description}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row.duration
                        ? formatDurationTextForDisplay(row.duration)
                        : "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row.clinical_note.length > 0 ? row.clinical_note : "-"}
                    </StyledTableCellHistory>
                  </StyledTableRowHistory>
                ))}
              </TableBody>
            </Table>
          </StyledTableContainer>
        </Grid>
      )}
    </>
  );
};
export const chiefComplaintsDataForQuickConsultation = (
  selectedSectionsData
) => {
  console.log("Chief Complaint Data", selectedSectionsData);
  return (
    <>
      {selectedSectionsData.length > 0 && (
        <Grid item xs={11}>
          <StyledTableContainer component={Paper}>
            <Table sx={{ minWidth: 500 }}>
              <TableHead>
                <StyledTableRowHistory>
                  <StyledTableCellHistoryForPreview>
                    Condition Name
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Clinical Status
                  </StyledTableCellHistoryForPreview>

                  <StyledTableCellHistoryForPreview>
                    Clinical Notes
                  </StyledTableCellHistoryForPreview>
                </StyledTableRowHistory>
              </TableHead>
              <TableBody>
                {selectedSectionsData.map((row, rowIndex) => (
                  <StyledTableRowHistory key={rowIndex}>
                    <StyledTableCellHistory>
                      {row.condition}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row.clinical_status_description}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row.clinical_note.length > 0 ? row.clinical_note : "-"}
                    </StyledTableCellHistory>
                  </StyledTableRowHistory>
                ))}
              </TableBody>
            </Table>
          </StyledTableContainer>
        </Grid>
      )}
    </>
  );
};
export const medicationsData = (selectedSectionsData) => {
  console.log("Medicine Data", selectedSectionsData);
  return (
    // <ul
    //   style={{
    //     listStyleType: "disc",
    //     padding: "0px 0px 0px 20px",
    //   }}
    // >
    //   {selectedSectionsData.length > 0 &&
    //     selectedSectionsData.map((medicine, index) => (
    //       <div
    //         style={{
    //           display: "flex",
    //           alignItems: "center",
    //           justifyContent: "space-between",
    //         }}
    //       >
    //         <li
    //           key={index}
    //           style={{
    //             fontWeight: "bold",
    //             color: "black",
    //             padding: "0px",
    //             margin: "5px",
    //             fontSize: "12px",
    //           }}
    //         >
    //           <div>
    //             {medicine.term}: {/* {medicine.frequency} */}
    //             {Array.isArray(medicine?.frequency)
    //               ? medicine.frequency.map((option) => option.term).join(", ")
    //               : medicine?.frequency || ""}{" "}
    //             {medicine?.duration
    //               ? `for ${medicine?.duration} ${medicine?.durationType}`
    //               : null}
    //             {/* - {medicine.instructions} */}{" "}
    //           </div>
    //           {medicine.reasons.length > 0 && (
    //             <div>Reasons - {medicine.reasons.join(", ")}</div>
    //           )}
    //           {medicine.selectedAdministration != null && (
    //             <div>
    //               Route Of Administration -{" "}
    //               {medicine.selectedAdministration.label}
    //             </div>
    //           )}
    //           {medicine.medicineNote.length > 0 && (
    //             <div>Note - {medicine.medicineNote}</div>
    //           )}
    //         </li>
    //       </div>
    //     ))}
    // </ul>
    <>
      {selectedSectionsData.length > 0 && (
        <Grid item xs={11}>
          <StyledTableContainer component={Paper}>
            <Table sx={{ minWidth: 500 }}>
              <TableHead>
                <StyledTableRowHistory>
                  <StyledTableCellHistoryForPreview>
                    Medicine Name
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Timing
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Frequency
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Dosage
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Additional Instructions
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Duration
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Reasons
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Route
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Notes
                  </StyledTableCellHistoryForPreview>
                </StyledTableRowHistory>
              </TableHead>
              <TableBody>
                {selectedSectionsData.map((row, rowIndex) => (
                  <StyledTableRowHistory key={rowIndex}>
                    <StyledTableCellHistory>{row?.term}</StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {[row?.time, row?.when].filter(Boolean).join(" ") || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.frequency || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.dosage || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {typeof row?.additionalInstructions === "string"
                        ? row?.additionalInstructions || "-"
                        : row?.additionalInstructions
                          ?.map((option) => option.term)
                          .join(", ") || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.duration
                        ? formatDurationTextForDisplay(row?.duration)
                        : "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.reasons.length > 0 ? row.reasons.join(", ") : "-"}
                    </StyledTableCellHistory>

                    <StyledTableCellHistory>
                      {row.selectedAdministration
                        ? row.selectedAdministration.label
                        : "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row.medicineNote.length > 0 ? row.medicineNote : "-"}
                    </StyledTableCellHistory>
                  </StyledTableRowHistory>
                ))}
              </TableBody>
            </Table>
          </StyledTableContainer>
        </Grid>
      )}
    </>
  );
};
export const proceduresData = (selectedSectionsData) => {
  return (
    // <ul
    //   style={{
    //     listStyleType: "disc",
    //     padding: "0px 0px 0px 20px",
    //   }}
    // >
    //   {selectedSectionsData.length > 0 &&
    //     selectedSectionsData.map((proc, index) => (
    //       <div
    //         style={{
    //           display: "flex",
    //           alignItems: "center",
    //           justifyContent: "space-between",
    //         }}
    //       >
    //         <li
    //           key={index}
    //           style={{
    //             fontWeight: "bold",
    //             color: "black",
    //             padding: "0px",
    //             margin: "5px",
    //             fontSize: "12px",
    //           }}
    //         >
    //           <span>
    //             {proc.term}
    //             {/* {proc.clinical_note ? "- " + proc.clinical_note : ""} */}
    //           </span>
    //           <br />
    //           <span>
    //             {proc.clinical_note
    //               ? "Clinical Note - " + proc.clinical_note
    //               : ""}
    //           </span>
    //         </li>
    //       </div>
    //     ))}
    // </ul>
    <>
      {selectedSectionsData.length > 0 && (
        <Grid item xs={10}>
          <StyledTableContainer component={Paper}>
            <Table>
              <TableHead>
                <StyledTableRowHistory>
                  <StyledTableCellHistoryForPreview>
                    Diagnosis Name
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Clinical Notes
                  </StyledTableCellHistoryForPreview>
                </StyledTableRowHistory>
              </TableHead>
              <TableBody>
                {selectedSectionsData.map((row, rowIndex) => (
                  <StyledTableRowHistory key={rowIndex}>
                    <StyledTableCellHistory>{row?.term}</StyledTableCellHistory>


                    <StyledTableCellHistory>
                      {row?.clinical_note || "-"}
                    </StyledTableCellHistory>
                  </StyledTableRowHistory>
                ))}
              </TableBody>
            </Table>
          </StyledTableContainer>
        </Grid>
      )}
    </>
  );
};

export const examinationsData = (
  hasVitalValue,
  vitals,
  bloodGroup,
  hasDentalData,
  dentalData
) => {
  if (
    (!hasVitalValue || !vitals || vitals.length === 0) &&
    !bloodGroup &&
    !hasDentalData
  ) {
    return null; // Return null if there's no vital value or vitals data or dental data
  }

  return (
    <div>
      {(hasVitalValue || bloodGroup) && (
        <>
          <p
            style={{
              fontWeight: 500,
              color: "#6A6A6A",
              fontSize: "12px",
              lineHeight: "1.5",
              marginBottom: "15px",
            }}
          >
            Vitals/Wellness
          </p>
          <Grid item xs={12}>
            <StyledTableContainer component={Paper}>
              <Table sx={{ minWidth: 500 }}>
                <TableHead>
                  <StyledTableRowHistory>
                    <StyledTableCellHistory>Temperature</StyledTableCellHistory>
                    <StyledTableCellHistory>Pulse</StyledTableCellHistory>
                    <StyledTableCellHistory>
                      Respiratory Rate
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      BP (Systolic / Diastolic)
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>SpO2</StyledTableCellHistory>
                    <StyledTableCellHistory>Weight</StyledTableCellHistory>
                    <StyledTableCellHistory>Height</StyledTableCellHistory>
                    <StyledTableCellHistory>BMI</StyledTableCellHistory>
                    <StyledTableCellHistory>Blood Group</StyledTableCellHistory>
                  </StyledTableRowHistory>
                </TableHead>

                <TableBody>
                  <StyledTableRowHistory>
                    <StyledTableCellHistory>
                      {vitals.find((v) => v.name === "Temperature")?.value ||
                        "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {vitals.find((v) => v.name === "Pulse")?.value || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {vitals.find((v) => v.name === "Respiratory Rate")
                        ?.value || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {vitals.find((v) => v.name === "BP")?.value || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {vitals.find((v) => v.name === "SPO2")?.value || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {vitals.find((v) => v.name === "Weight")?.value || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {vitals.find((v) => v.name === "Height")?.value || "-"}
                    </StyledTableCellHistory>

                    {/* BMI calculation inside the Table */}
                    <StyledTableCellHistory>
                      {vitals.some(
                        (item) => item.name === "Height" && item.value !== ""
                      ) &&
                        vitals.some(
                          (item) => item.name === "Weight" && item.value !== ""
                        ) ? (
                        <>
                          {(
                            parseFloat(
                              vitals.find((item) => item.name === "Weight")
                                ?.value
                            ) /
                            Math.pow(
                              parseFloat(
                                vitals.find((item) => item.name === "Height")
                                  ?.value
                              ) / 100,
                              2
                            )
                          ).toFixed(2)}{" "}
                          kg/m²
                        </>
                      ) : (
                        "-"
                      )}
                    </StyledTableCellHistory>

                    <StyledTableCellHistory>
                      {bloodGroup || "-"}
                    </StyledTableCellHistory>
                  </StyledTableRowHistory>
                </TableBody>
              </Table>
            </StyledTableContainer>
          </Grid>
        </>
      )}

      {hasDentalData && (
        <>
          <p
            style={{
              fontWeight: 500,
              color: "#6A6A6A",
              fontSize: "12px",
              lineHeight: "1.5",
              marginBottom: "15px",
            }}
          >
            Dental Data
          </p>
          <Grid item xs={12} sm={6}>
            <StyledTableContainer component={Paper}>
              <Table sx={{ minWidth: 100 }}>
                <TableHead>
                  <StyledTableRowHistory>
                    <StyledTableCellHistory>
                      Teeth FDI No.
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      Clinical Notes
                    </StyledTableCellHistory>
                  </StyledTableRowHistory>
                </TableHead>

                <TableBody>
                  {dentalData.map((note, index) => (
                    <StyledTableRowHistory key={index}>
                      <StyledTableCellHistory>
                        {
                          note.id
                            .split(",") // Split by comma to handle multiple IDs
                            .map((id) => id.replace("_", "")) // Remove underscore
                            .join(",") // Join back with commas
                        }
                        {note?.source === "voice" && (
                          <Tooltip title="Machine-interpreted text — please verify before confirming">
                            <span className="missing-id-warning">⚠️</span>
                          </Tooltip>
                        )}
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {note.clinical_note}
                      </StyledTableCellHistory>
                    </StyledTableRowHistory>
                  ))}
                </TableBody>
              </Table>
            </StyledTableContainer>
          </Grid>
        </>
      )}
    </div>
  );
};
export const examinationsDataForPreview = (
  hasVitalValue,
  vitals,
  bloodGroup,
  hasDentalData,
  dentalData
) => {
  if (
    (!hasVitalValue || !vitals || vitals.length === 0) &&
    !bloodGroup &&
    !hasDentalData
  ) {
    return null; // Return null if there's no vital value or vitals data or dental data
  }

  return (
    <div>
      {(hasVitalValue || bloodGroup) && (
        <>
          <p
            style={{
              fontWeight: 500,
              color: "#6A6A6A",
              fontSize: "12px",
              lineHeight: "1.5",
              marginBottom: "15px",
            }}
          >
            Vitals/Wellness
          </p>
          <Grid item xs={11}>
            <StyledTableContainer component={Paper}>
              <Table sx={{ minWidth: 500 }}>
                <TableHead>
                  <StyledTableRowHistory>
                    <StyledTableCellHistoryForPreview>
                      Temperature
                    </StyledTableCellHistoryForPreview>
                    <StyledTableCellHistoryForPreview>
                      Pulse
                    </StyledTableCellHistoryForPreview>
                    <StyledTableCellHistoryForPreview>
                      Respiratory Rate
                    </StyledTableCellHistoryForPreview>
                    <StyledTableCellHistoryForPreview>
                      BP (Systolic / Diastolic)
                    </StyledTableCellHistoryForPreview>
                    <StyledTableCellHistoryForPreview>
                      SpO2
                    </StyledTableCellHistoryForPreview>
                    <StyledTableCellHistoryForPreview>
                      Weight
                    </StyledTableCellHistoryForPreview>
                    <StyledTableCellHistoryForPreview>
                      Height
                    </StyledTableCellHistoryForPreview>
                    <StyledTableCellHistoryForPreview>
                      BMI
                    </StyledTableCellHistoryForPreview>
                    <StyledTableCellHistoryForPreview>
                      Blood Group
                    </StyledTableCellHistoryForPreview>
                  </StyledTableRowHistory>
                </TableHead>

                <TableBody>
                  <StyledTableRowHistory>
                    <StyledTableCellHistory>
                      {vitals.find((v) => v.name === "Temperature")?.value ||
                        "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {vitals.find((v) => v.name === "Pulse")?.value || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {vitals.find((v) => v.name === "Respiratory Rate")
                        ?.value || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {vitals.find((v) => v.name === "BP")?.value || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {vitals.find((v) => v.name === "SPO2")?.value || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {vitals.find((v) => v.name === "Weight")?.value || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {vitals.find((v) => v.name === "Height")?.value || "-"}
                    </StyledTableCellHistory>

                    {/* BMI calculation inside the Table */}
                    <StyledTableCellHistory>
                      {vitals.some(
                        (item) => item.name === "Height" && item.value !== ""
                      ) &&
                        vitals.some(
                          (item) => item.name === "Weight" && item.value !== ""
                        ) ? (
                        <>
                          {(
                            parseFloat(
                              vitals.find((item) => item.name === "Weight")
                                ?.value
                            ) /
                            Math.pow(
                              parseFloat(
                                vitals.find((item) => item.name === "Height")
                                  ?.value
                              ) / 100,
                              2
                            )
                          ).toFixed(2)}{" "}
                          kg/m²
                        </>
                      ) : (
                        "-"
                      )}
                    </StyledTableCellHistory>

                    <StyledTableCellHistory>
                      {bloodGroup || "-"}
                    </StyledTableCellHistory>
                  </StyledTableRowHistory>
                </TableBody>
              </Table>
            </StyledTableContainer>
          </Grid>
        </>
      )}

      {hasDentalData && (
        <>
          <p
            style={{
              fontWeight: 500,
              color: "#6A6A6A",
              fontSize: "12px",
              lineHeight: "1.5",
              marginBottom: "15px",
            }}
          >
            Dental Data
          </p>
          <Grid item xs={12} sm={6}>
            <StyledTableContainer component={Paper}>
              <Table sx={{ minWidth: 100 }}>
                <TableHead>
                  <StyledTableRowHistory>
                    <StyledTableCellHistory>
                      Teeth FDI No.
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      Clinical Notes
                    </StyledTableCellHistory>
                  </StyledTableRowHistory>
                </TableHead>

                <TableBody>
                  {dentalData.map((note, index) => (
                    <StyledTableRowHistory key={index}>
                      <StyledTableCellHistory>
                        {
                          note.id
                            .split(",") // Split by comma to handle multiple IDs
                            .map((id) => id.replace("_", "")) // Remove underscore
                            .join(",") // Join back with commas
                        }
                      </StyledTableCellHistory>
                      <StyledTableCellHistory>
                        {note.clinical_note}
                      </StyledTableCellHistory>
                    </StyledTableRowHistory>
                  ))}
                </TableBody>
              </Table>
            </StyledTableContainer>
          </Grid>
        </>
      )}
    </div>
  );
};

export const appointmentData = (
  selectedSectionsFollowUpData,
  selectedSectionsReferralData,
  followUpError,
  referralError,
  selectedSectionsIpdData = [],
  ipdReferralError = {}
) => {
  console.log("Follow Up data", selectedSectionsFollowUpData[0], followUpError);
  console.log("Referral data", selectedSectionsReferralData[0], referralError);
  console.log("IPD Referral data", selectedSectionsIpdData[0], ipdReferralError);

  // If there are any validation errors, exit early
  if (
    Object.keys(followUpError).length !== 0 ||
    Object.keys(referralError).length !== 0 ||
    Object.keys(ipdReferralError).length !== 0
  ) {
    return null;
  }

  const followUpData = selectedSectionsFollowUpData[0];
  const referralData = selectedSectionsReferralData[0];
  const ipdData =
    selectedSectionsIpdData && selectedSectionsIpdData.length > 0
      ? selectedSectionsIpdData[0]
      : null;
  console.log("Data in follow up data", followUpData);
  console.log("Data in referral data", referralData);
  console.log("Data in ipd referral data", ipdData);

  // If there is no data present, exit early
  if (
    followUpData &&
    followUpData.service_type.length == 0 &&
    referralData &&
    referralData.service_description.length == 0 &&
    (!ipdData || !ipdData.admission_details)
  ) {
    return null;
  }
  return (
    <Grid container spacing={2}>
      {/* Follow Up Table */}
      {followUpData?.service_type?.length > 0 && (
        <Grid item xs={12}>
          <p
            style={{
              fontWeight: 500,
              color: "#6A6A6A",
              fontSize: "12px",
              lineHeight: "1.5",
              // marginBottom: "15px",
            }}
          >
            Follow Up
          </p>
          <StyledTableContainer component={Paper}>
            <Table>
              <TableHead>
                <StyledTableRowHistory>
                  <StyledTableCellHistoryForPreview>
                    Follow Up Description
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Follow Up Duration
                  </StyledTableCellHistoryForPreview>
                </StyledTableRowHistory>
              </TableHead>
              <TableBody>
                <StyledTableRowHistory>
                  <StyledTableCellHistory>
                    {followUpData?.service_type || "-"}
                  </StyledTableCellHistory>

                  <StyledTableCellHistory>
                    {followUpData?.duration?.length > 0
                      ? `Follow Up after ${formatDurationTextForDisplay(
                        followUpData?.duration
                      )}`
                      : "-"}
                  </StyledTableCellHistory>
                </StyledTableRowHistory>
              </TableBody>
            </Table>
          </StyledTableContainer>
        </Grid>
      )}

      {/* Referral Table */}
      {referralData?.service_description?.length > 0 && (
        <Grid item xs={12}>
          <p
            style={{
              fontWeight: 500,
              color: "#6A6A6A",
              fontSize: "12px",
              lineHeight: "1.5",
              // marginBottom: "15px",
            }}
          >
            Referral
          </p>
          <StyledTableContainer component={Paper}>
            <Table>
              <TableHead>
                <StyledTableRowHistory>
                  <StyledTableCellHistoryForPreview>
                    Referral Details
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Referral Doctor
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Department
                  </StyledTableCellHistoryForPreview>
                </StyledTableRowHistory>
              </TableHead>
              <TableBody>
                <StyledTableRowHistory>
                  <StyledTableCellHistory>
                    {referralData.service_description?.length > 0
                      ? referralData?.service_description
                      : "-"}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {referralData?.doctor_details?.name || "N/A"}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {referralData?.service_category || "-"}
                  </StyledTableCellHistory>
                </StyledTableRowHistory>
              </TableBody>
            </Table>
          </StyledTableContainer>
        </Grid>
      )}

      {/* IPD Admission Referral Table */}
      {ipdData?.admission_details && ipdData.admission_details.length > 0 && (
        <Grid item xs={12}>
          <p
            style={{
              fontWeight: 500,
              color: "#6A6A6A",
              fontSize: "12px",
              lineHeight: "1.5",
              // marginBottom: "15px",
            }}
          >
            Admission
          </p>
          <StyledTableContainer component={Paper}>
            <Table>
              <TableHead>
                <StyledTableRowHistory>
                  <StyledTableCellHistoryForPreview>
                    Admission Details
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Admission Type
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Expected Date
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Referred Doctor
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Department
                  </StyledTableCellHistoryForPreview>
                </StyledTableRowHistory>
              </TableHead>
              <TableBody>
                <StyledTableRowHistory>
                  <StyledTableCellHistory>
                    {ipdData.admission_details}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {ipdData.admission_type || "-"}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {ipdData.expected_date
                      ? formatDateYYYYMMDD(ipdData.expected_date)
                      : "-"}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {ipdData?.doctor_details?.name || "N/A"}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {ipdData?.service_category || "-"}
                  </StyledTableCellHistory>
                </StyledTableRowHistory>
              </TableBody>
            </Table>
          </StyledTableContainer>
        </Grid>
      )}
    </Grid>
  );
};

export const adviceData = (
  selectedSectionsAdviceData
  // adviceError,
) => {
  console.log("Advice data", selectedSectionsAdviceData);

  // If there are any validation errors, exit early
  // if (
  //   Object.keys(followUpError).length !== 0 ||
  //   Object.keys(referralError).length !== 0
  // ) {
  //   return null;
  // }

  // If there is no data present, exit early
  if (
    !selectedSectionsAdviceData ||
    !selectedSectionsAdviceData.advice ||
    selectedSectionsAdviceData?.advice.trim().length === 0
  ) {
    return null;
  }

  return (
    <Grid container spacing={2}>
      {selectedSectionsAdviceData?.advice?.length > 0 && (
        <Grid item xs={12}>
          {/* <p
            style={{
              fontWeight: 500,
              color: "#6A6A6A",
              fontSize: "12px",
              lineHeight: "1.5",
              marginBottom: "15px",
            }}
          >
            Medical Advice
          </p> */}
          <StyledTableContainer component={Paper}>
            <Table>
              <TableHead>
                <StyledTableRowHistory>
                  <StyledTableCellHistoryForPreview>
                    Medical Advice
                  </StyledTableCellHistoryForPreview>
                </StyledTableRowHistory>
              </TableHead>
              <TableBody>
                <StyledTableRowHistory>
                  <StyledTableCellHistory
                    sx={{
                      whiteSpace: "pre-line",
                      wordBreak: "break-word",
                    }}
                  >
                    {selectedSectionsAdviceData?.advice || "-"}
                  </StyledTableCellHistory>
                </StyledTableRowHistory>
              </TableBody>
            </Table>
          </StyledTableContainer>
        </Grid>
      )}
    </Grid>
  );
};

export const investigationData = (selectedSectionsData) => {
  return (
    // <ul
    //   style={{
    //     listStyleType: "disc",
    //     padding: "0px 0px 0px 20px",
    //   }}
    // >
    //   {selectedSectionsData.length > 0 &&
    //     selectedSectionsData.map((data, index) => (
    //       <div
    //         style={{
    //           display: "flex",
    //           alignItems: "center",
    //           justifyContent: "space-between",
    //         }}
    //       >
    //         <li
    //           key={index}
    //           style={{
    //             fontWeight: "bold",
    //             color: "black",
    //             padding: "0px",
    //             margin: "5px",
    //             fontSize: "12px",
    //           }}
    //         >
    //           <span>
    //             {data.term}
    //             {data?.body_part ? `, ${data.body_part}` : ""}
    //             {data?.laterality ? `, ${data.laterality}` : ""}
    //             {data?.position ? `, ${data.position}` : ""}
    //           </span>
    //           <br />
    //           <span>
    //             {data.clinical_note
    //               ? "Clinical Note - " + data.clinical_note
    //               : ""}
    //           </span>
    //         </li>
    //       </div>
    //     ))}
    // </ul>
    <>
      {selectedSectionsData.length > 0 && (
        <Grid item xs={10}>
          <StyledTableContainer component={Paper}>
            <Table>
              <TableHead>
                <StyledTableRowHistory>
                  <StyledTableCellHistoryForPreview>
                    Test/Investigation Name
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Anatomical Region
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Laterality
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Patient Position
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Clinical Notes
                  </StyledTableCellHistoryForPreview>
                </StyledTableRowHistory>
              </TableHead>
              <TableBody>
                {selectedSectionsData.map((row, rowIndex) => (
                  <StyledTableRowHistory key={rowIndex}>
                    <StyledTableCellHistory>{row?.term}</StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.body_part || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.laterality || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.position || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.clinical_note || "-"}
                    </StyledTableCellHistory>
                  </StyledTableRowHistory>
                ))}
              </TableBody>
            </Table>
          </StyledTableContainer>
        </Grid>
      )}
    </>
  );
};
export const investigationDataForQuickConsultation = (selectedSectionsData) => {
  return (
    <>
      {selectedSectionsData.length > 0 && (
        <Grid item xs={10}>
          <StyledTableContainer component={Paper}>
            <Table>
              <TableHead>
                <StyledTableRowHistory>
                  <StyledTableCellHistoryForPreview>
                    Test/Investigation Name
                  </StyledTableCellHistoryForPreview>

                  <StyledTableCellHistoryForPreview>
                    Clinical Notes
                  </StyledTableCellHistoryForPreview>
                </StyledTableRowHistory>
              </TableHead>
              <TableBody>
                {selectedSectionsData.map((row, rowIndex) => (
                  <StyledTableRowHistory key={rowIndex}>
                    <StyledTableCellHistory>{row?.term}</StyledTableCellHistory>

                    <StyledTableCellHistory>
                      {row?.clinical_note || "-"}
                    </StyledTableCellHistory>
                  </StyledTableRowHistory>
                ))}
              </TableBody>
            </Table>
          </StyledTableContainer>
        </Grid>
      )}
    </>
  );
};
export const diagnosisData = (selectedSectionsData) => {
  return (
    <>
      {selectedSectionsData.length > 0 && (
        <Grid item xs={10}>
          <StyledTableContainer component={Paper}>
            <Table>
              <TableHead>
                <StyledTableRowHistory>
                  <StyledTableCellHistoryForPreview>
                    Diagnosis Name
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Duration
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Clinical Notes
                  </StyledTableCellHistoryForPreview>
                </StyledTableRowHistory>
              </TableHead>
              <TableBody>
                {selectedSectionsData.map((row, rowIndex) => (
                  <StyledTableRowHistory key={rowIndex}>
                    <StyledTableCellHistory>{row?.term}</StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.duration
                        ? formatDurationTextForDisplay(row.duration)
                        : "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.clinical_note || "-"}
                    </StyledTableCellHistory>
                  </StyledTableRowHistory>
                ))}
              </TableBody>
            </Table>
          </StyledTableContainer>
        </Grid>
      )}
    </>
  );
};

export const otherSectionsData = (selectedSectionsData) => {
  return (
    <ul
      style={{
        listStyleType: "disc",
        padding: "0px 0px 0px 20px",
      }}
    >
      {selectedSectionsData.length > 0 &&
        selectedSectionsData.map((data, index) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <li
              key={index}
              style={{
                fontWeight: "bold",
                color: "black",
                padding: "0px",
                margin: "5px",
                fontSize: "12px",
              }}
            >
              <span>{data.term}</span>
              <br />
              <span>
                {[
                  data.duration
                    ? `Duration - ${data.duration}`
                    : null,
                  data.clinical_note
                    ? `Clinical Note - ${data.clinical_note}`
                    : null,
                ]
                  .filter(Boolean)
                  .join(" | ")}
              </span>
            </li>
          </div>
        ))}
    </ul>
  );
};
const renderEachHistorySectionTable = (sectionName, sectionValue) => {
  console.log(sectionName, sectionValue);
  switch (sectionName) {
    case "History of Past Illness":
    case "History of Present Illness":
      return MedicalHistoryTable(sectionValue);
    case "Family History":
      return FamilyHistoryTable(sectionValue);
    case "Drug History":
      return DrugHistoryTable(sectionValue);
    case "Allergies":
      return AllergiesTable(sectionValue);
    case "Addiction History":
      return AddictionHistoryTable(sectionValue);
    case "Surgeries":
      return SurgeriesTable(sectionValue);
    case "Menstrual History":
      return MenstrualHistoryTable(sectionValue);
    case "Adult Vaccination":
      return <AdultVaccinationData data={sectionValue} />;
    // case "Initial Observation":
    //   return initialObservationData(sectionValue);
  }
};

export const historyData = (history) => {
  console.log("History Data", history);
  let prevDataPresent = false,
    newDataPresent = false;
  for (const category in history) {
    const { prev, new: newData } = history[category];
    if (prev.length > 0) prevDataPresent = true;
    if (newData.length > 0) newDataPresent = true;
  }
  return (
    <div>
      {newDataPresent && (
        <>
          <p
            style={{
              fontWeight: 500,
              color: "black",
              fontSize: "12px",
              lineHeight: "1.5",
              marginBottom: "15px",
            }}
          >
            Recent Data
          </p>
          {Object.entries(history).map(
            ([sectionKey, sectionValue]) =>
              sectionValue["new"].length > 0 && (
                <ul
                  key={sectionKey}
                  style={{
                    listStyleType: "disc",
                    padding: "0px 0px 0px 20px",
                  }}
                >
                  <li
                    style={{
                      fontWeight: "bold",
                      color: "black",
                      padding: "0px",
                      margin: "5px",
                      fontSize: "12px",
                    }}
                  >
                    <div>{sectionKey}</div>
                    <div>
                      {renderEachHistorySectionTable(
                        sectionKey,
                        sectionValue["new"]
                      )}
                    </div>
                  </li>
                </ul>
              )
          )}
        </>
      )}

      {/* Displaying Old (Previous) Data */}
      {prevDataPresent && (
        <>
          <p
            style={{
              fontWeight: 500,
              color: "black",
              fontSize: "12px",
              lineHeight: "1.5",
              marginBottom: "15px",
            }}
          >
            Old Data
          </p>
          {Object.entries(history).map(
            ([sectionKey, sectionValue]) =>
              sectionValue["prev"].length > 0 && (
                <ul
                  key={sectionKey}
                  style={{
                    listStyleType: "disc",
                    padding: "0px 0px 0px 20px",
                  }}
                >
                  <li
                    style={{
                      fontWeight: "bold",
                      color: "black",
                      padding: "0px",
                      margin: "5px",
                      fontSize: "12px",
                    }}
                  >
                    <div>{sectionKey}</div>
                    <div>
                      {renderEachHistorySectionTable(
                        sectionKey,
                        sectionValue["prev"]
                      )}
                    </div>
                  </li>
                </ul>
              )
          )}
        </>
      )}
    </div>
  );
};

export const examinationsHistoryData = (history) => {
  console.log("History Data", history);
  let prevDataPresent = false,
    newDataPresent = false;
  for (const category in history) {
    if (category == "Addiction History" || category == "Menstrual History") {
      const { prev, new: newData } = history[category];
      if (prev.length > 0) prevDataPresent = true;
      if (newData.length > 0) newDataPresent = true;
    }
  }
  return (
    <div>
      {newDataPresent && (
        <>
          <p
            style={{
              fontWeight: 500,
              color: "black",
              fontSize: "12px",
              lineHeight: "1.5",
              marginBottom: "15px",
            }}
          >
            Recent Data
          </p>
          {Object.entries(history).map(
            ([sectionKey, sectionValue]) =>
              (sectionKey == "Addiction History" ||
                sectionKey == "Menstrual History") &&
              sectionValue["new"].length > 0 && (
                <ul
                  key={sectionKey}
                  style={{
                    listStyleType: "disc",
                    padding: "0px 0px 0px 20px",
                  }}
                >
                  <li
                    style={{
                      fontWeight: "bold",
                      color: "black",
                      padding: "0px",
                      margin: "5px",
                      fontSize: "12px",
                    }}
                  >
                    <div>{sectionKey}</div>
                    <div>
                      {renderEachHistorySectionTable(
                        sectionKey,
                        sectionValue["new"]
                      )}
                    </div>
                  </li>
                </ul>
              )
          )}
        </>
      )}

      {/* Displaying Old (Previous) Data */}
      {prevDataPresent && (
        <>
          <p
            style={{
              fontWeight: 500,
              color: "black",
              fontSize: "12px",
              lineHeight: "1.5",
              marginBottom: "15px",
            }}
          >
            Old Data
          </p>
          {Object.entries(history).map(
            ([sectionKey, sectionValue]) =>
              (sectionKey == "Addiction History" ||
                sectionKey == "Menstrual History") &&
              sectionValue["prev"].length > 0 && (
                <ul
                  key={sectionKey}
                  style={{
                    listStyleType: "disc",
                    padding: "0px 0px 0px 20px",
                  }}
                >
                  <li
                    style={{
                      fontWeight: "bold",
                      color: "black",
                      padding: "0px",
                      margin: "5px",
                      fontSize: "12px",
                    }}
                  >
                    <div>{sectionKey}</div>
                    <div>
                      {renderEachHistorySectionTable(
                        sectionKey,
                        sectionValue["prev"]
                      )}
                    </div>
                  </li>
                </ul>
              )
          )}
        </>
      )}
    </div>
  );
};

const MedicalHistoryTable = (medicalHistoryData) => {
  const brandingData = useContext(BrandingContext);
  const brandingItem = brandingData?.find(
    (item) => item.name === "branding_statements"
  );
  const brandingContent = brandingItem?.content || null;

  // Access the themeColour if the object is found
  const themeColour = brandingContent?.themeColour || "#21cdc0";

  // console.log(themeColour); // Output: #007aff
  // console.log("Branding Data In History", brandingData);
  return (
    <Grid item xs={12} sm={11}>
      {medicalHistoryData.length > 0 && (
        <TableContainer
          component={Paper}
          sx={{
            margin: "5px 2px",
            border: "1px solid #21cdc0",
          }}
        >
          <Table>
            <TableHead>
              <StyledTableRowHistory>
                <StyledTableCellHistoryForPreview>
                  Condition
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Clinical Notes
                </StyledTableCellHistoryForPreview>

                <StyledTableCellHistoryForPreview>
                  Clinical Status
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Condition Onset
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Condition Duration
                </StyledTableCellHistoryForPreview>
              </StyledTableRowHistory>
            </TableHead>
            <TableBody>
              {medicalHistoryData.map((row, rowIndex) => (
                <StyledTableRowHistory key={rowIndex}>
                  {/* {console.log("History of Past Illness row", row)} */}

                  <StyledTableCellHistory>
                    {row.condition}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory sx={{ width: "35%" }}>
                    {row?.clinical_note?.length > 0 ? row.clinical_note : "-"}
                  </StyledTableCellHistory>

                  <StyledTableCellHistory>
                    {row?.clinical_status_description ?? "-"}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {row?.onset_datetime
                      ? formatDurationTextForDisplay(
                        getHumanReadableDiffInPastDateWithAgo(
                          row?.onset_datetime,
                          row
                        )
                      )
                      : "-"}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {row?.abatement_datetime
                      ? formatDurationTextForDisplay(
                        getHumanReadableDurationInDate(
                          row?.onset_datetime,
                          row?.abatement_datetime,
                          row
                        )
                      )
                      : "-"}
                  </StyledTableCellHistory>
                </StyledTableRowHistory>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Grid>
  );
};
const FamilyHistoryTable = (familyHistoryData) => {
  const brandingData = useContext(BrandingContext);
  const brandingItem = brandingData?.find(
    (item) => item.name === "branding_statements"
  );
  const brandingContent = brandingItem?.content || null;

  // Access the themeColour if the object is found
  const themeColour = brandingContent?.themeColour || "#21cdc0";
  return (
    <Grid item xs={12} sm={11}>
      {familyHistoryData.length > 0 && (
        <TableContainer
          component={Paper}
          sx={{
            marginTop: "20px",
            border: "1px solid #21cdc0",
          }}
        >
          <Table>
            <TableHead>
              <StyledTableRowHistory>
                <StyledTableCellHistoryForPreview>
                  Relation
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Condition
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  On Set Age
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Deceased
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Clinical Notes
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Condition Onset
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Condition Duration
                </StyledTableCellHistoryForPreview>
              </StyledTableRowHistory>
            </TableHead>
            <TableBody>
              {familyHistoryData.map((row, rowIndex) => (
                <StyledTableRowHistory key={rowIndex}>
                  <StyledTableCellHistory>
                    {row?.relation || "-"}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {row?.condition || "-"}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {row?.onSetAge
                      ? isNaN(row?.onSetAge)
                        ? "-"
                        : row?.onSetAge
                      : "-"}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {row?.deceased ? "Yes" : "No"}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {row?.clinical_note || "-"}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {row?.onset_datetime
                      ? formatDurationTextForDisplay(
                        getHumanReadableDiffInPastDateWithAgo(
                          row?.onset_datetime,
                          row
                        )
                      )
                      : "-"}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {row?.abatement_datetime
                      ? formatDurationTextForDisplay(
                        getHumanReadableDurationInDate(
                          row?.onset_datetime,
                          row?.abatement_datetime,
                          row
                        )
                      )
                      : "-"}
                  </StyledTableCellHistory>
                </StyledTableRowHistory>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Grid>
  );
};
const DrugHistoryTable = (drugHistoryData) => {
  const brandingData = useContext(BrandingContext);
  const brandingItem = brandingData?.find(
    (item) => item.name === "branding_statements"
  );
  const brandingContent = brandingItem?.content || null;

  // Access the themeColour if the object is found
  const themeColour = brandingContent?.themeColour || "#21cdc0";
  return (
    <Grid item xs={12} sm={11}>
      {drugHistoryData.length > 0 && (
        <TableContainer
          component={Paper}
          sx={{
            marginTop: "20px",
            border: "1px solid #21cdc0",
          }}
        >
          <Table>
            <TableHead>
              <StyledTableRowHistory>
                <StyledTableCellHistoryForPreview>
                  Drug Name
                </StyledTableCellHistoryForPreview>

                <StyledTableCellHistoryForPreview>
                  Drug Onset
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Drug Duration
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Clinical Notes
                </StyledTableCellHistoryForPreview>
              </StyledTableRowHistory>
            </TableHead>
            <TableBody>
              {drugHistoryData.map((row, rowIndex) => {
                // console.log("Drug Row", row); // Logging the row object

                return (
                  <StyledTableRowHistory key={rowIndex}>
                    <StyledTableCellHistory>
                      {row?.drug_name}
                    </StyledTableCellHistory>

                    <StyledTableCellHistory>
                      {row?.onset_datetime
                        ? formatDurationTextForDisplay(
                          getHumanReadableDiffInPastDateWithAgo(
                            row?.onset_datetime,
                            row
                          )
                        )
                        : "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.abatement_datetime
                        ? formatDurationTextForDisplay(
                          getHumanReadableDurationInDate(
                            row?.onset_datetime,
                            row?.abatement_datetime,
                            row
                          )
                        )
                        : "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.clinical_note ?? "-"}
                    </StyledTableCellHistory>
                  </StyledTableRowHistory>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Grid>
  );
};
const AllergiesTable = (allergyHistoryData) => {
  const brandingData = useContext(BrandingContext);
  const brandingItem = brandingData?.find(
    (item) => item.name === "branding_statements"
  );
  const brandingContent = brandingItem?.content || null;

  // Access the themeColour if the object is found
  const themeColour = brandingContent?.themeColour || "#21cdc0";
  return (
    <Grid item xs={12} sm={11}>
      {allergyHistoryData.length > 0 && (
        <TableContainer
          component={Paper}
          sx={{
            marginTop: "20px",
            border: "1px solid #21cdc0",
          }}
        >
          <Table>
            <TableHead>
              <StyledTableRowHistory>
                <StyledTableCellHistoryForPreview>
                  Allergy Type
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Allergy Description
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Note
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Clinical Status
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Allergy Onset
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Allergy Duration
                </StyledTableCellHistoryForPreview>
              </StyledTableRowHistory>
            </TableHead>
            <TableBody>
              {allergyHistoryData.map((row, rowIndex) => {
                // console.log("Allergy Row", row); // Logging the row object

                return (
                  <StyledTableRowHistory key={rowIndex}>
                    <StyledTableCellHistory>
                      {row.allergy_type
                        ? row.allergy_type.charAt(0).toUpperCase() +
                        row.allergy_type.slice(1)
                        : "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.allergy_description}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.note === "" ? "-" : row?.note}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.clinical_status_description === ""
                        ? "-"
                        : row?.clinical_status_description}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.onset_datetime
                        ? formatDurationTextForDisplay(
                          getHumanReadableDiffInPastDateWithAgo(
                            row?.onset_datetime,
                            row
                          )
                        )
                        : "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.abatement_datetime
                        ? formatDurationTextForDisplay(
                          getHumanReadableDurationInDate(
                            row?.onset_datetime,
                            row?.abatement_datetime,
                            row
                          )
                        )
                        : "-"}
                    </StyledTableCellHistory>
                  </StyledTableRowHistory>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Grid>
  );
};
const AddictionHistoryTable = (addictionHistoryData) => {
  const brandingData = useContext(BrandingContext);
  const brandingItem = brandingData?.find(
    (item) => item.name === "branding_statements"
  );
  const brandingContent = brandingItem?.content || null;

  // Access the themeColour if the object is found
  const themeColour = brandingContent?.themeColour || "#21cdc0";
  return (
    <Grid item xs={12} sm={11}>
      {addictionHistoryData.length > 0 && (
        <TableContainer
          component={Paper}
          sx={{
            marginTop: "20px",
            border: "1px solid #21cdc0",
          }}
        >
          <Table>
            <TableHead>
              <StyledTableRowHistory>
                <StyledTableCellHistoryForPreview>
                  Addiction Type
                </StyledTableCellHistoryForPreview>

                <StyledTableCellHistoryForPreview>
                  Addiction Description
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Addiction Onset
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Addiction Duration
                </StyledTableCellHistoryForPreview>
              </StyledTableRowHistory>
            </TableHead>
            <TableBody>
              {addictionHistoryData.map((row, rowIndex) => {
                // console.log("Addiction Row", row); // Logging the row object

                return (
                  <StyledTableRowHistory key={rowIndex}>
                    <StyledTableCellHistory>
                      {row?.addiction_type}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.addiction_description}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.onset_datetime
                        ? formatDurationTextForDisplay(
                          getHumanReadableDiffInPastDateWithAgo(
                            row?.onset_datetime,
                            row
                          )
                        )
                        : "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row?.abatement_datetime
                        ? formatDurationTextForDisplay(
                          getHumanReadableDurationInDate(
                            row?.onset_datetime,
                            row?.abatement_datetime,
                            row
                          )
                        )
                        : "-"}
                    </StyledTableCellHistory>
                  </StyledTableRowHistory>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Grid>
  );
};
const SurgeriesTable = (surgicalHistoryData) => {
  const brandingData = useContext(BrandingContext);
  const brandingItem = brandingData?.find(
    (item) => item.name === "branding_statements"
  );
  const brandingContent = brandingItem?.content || null;

  // Access the themeColour if the object is found
  const themeColour = brandingContent?.themeColour || "#21cdc0";
  return (
    <Grid item xs={11} sm={11} md={11}>
      {surgicalHistoryData.length > 0 && (
        <TableContainer
          component={Paper}
          sx={{
            marginTop: "20px",
            border: "1px solid #21cdc0",
          }}
        >
          <Table>
            <TableHead>
              <StyledTableRowHistory>
                <StyledTableCellHistoryForPreview>
                  Procedure Name
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Clinical Notes
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Follow Up Description
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Time Since Surgery
                </StyledTableCellHistoryForPreview>
              </StyledTableRowHistory>
            </TableHead>
            <TableBody>
              {surgicalHistoryData.map((row, rowIndex) => (
                <StyledTableRowHistory key={rowIndex}>
                  <StyledTableCellHistory>
                    {row.procedure}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {row?.clinical_note || "-"}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {row?.follow_up_description || "-"}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {row?.recorded_date
                      ? formatDurationTextForDisplay(
                        getHumanReadableDiffInPastDateWithAgo(row?.recorded_date, row)
                      )
                      : "-"}
                  </StyledTableCellHistory>
                </StyledTableRowHistory>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Grid>
  );
};
const MenstrualHistoryTable = (menstrualHistoryData) => {
  const brandingData = useContext(BrandingContext);
  const brandingItem = brandingData?.find(
    (item) => item.name === "branding_statements"
  );
  const brandingContent = brandingItem?.content || null;

  // Access the themeColour if the object is found
  const themeColour = brandingContent?.themeColour || "#21cdc0";
  return (
    <Grid item xs={11} sm={11} md={11}>
      {menstrualHistoryData.length > 0 && (
        <TableContainer
          component={Paper}
          sx={{
            marginTop: "20px",
            border: "1px solid #21cdc0",
          }}
        >
          <Table>
            <TableHead>
              <StyledTableRowHistory>
                <StyledTableCellHistoryForPreview>
                  Type
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Description
                </StyledTableCellHistoryForPreview>
                <StyledTableCellHistoryForPreview>
                  Time Since Observation
                </StyledTableCellHistoryForPreview>
              </StyledTableRowHistory>
            </TableHead>
            <TableBody>
              {menstrualHistoryData.map((row, rowIndex) => (
                <StyledTableRowHistory key={rowIndex}>
                  <StyledTableCellHistory>
                    {row?.menstrualType ?? "-"}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {row?.description}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {row?.duration
                      ? formatDurationTextForDisplay(row.duration)
                      : row?.durationType
                        ? formatDurationTextForDisplay(
                          `${row?.duration || ""} ${row.durationType}`.trim()
                        )
                        : row?.date
                          ? formatDurationTextForDisplay(
                            getHumanReadableDiffInPastDateWithAgo(row?.date, row)
                          )
                          : "-"}
                  </StyledTableCellHistory>
                </StyledTableRowHistory>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Grid>
  );
};
// export const initialObservationData = (data) => {
//   const themeColour = "#21cdc0";

//   if (!Array.isArray(data) || data.length === 0) return null;

//   return (
//     <Grid item xs={12} sm={11}>
//       <TableContainer
//         component={Paper}
//         sx={{ margin: "5px 2px", border: "1px solid #21cdc0" }}
//       >
//         <Table>
//           <TableHead>
//             <StyledTableRowHistory>
//               <StyledTableCellHistory bgColor={themeColour}>
//                 Panel
//               </StyledTableCellHistory>
//               <StyledTableCellHistory bgColor={themeColour}>
//                 Test Name
//               </StyledTableCellHistory>
//               <StyledTableCellHistory bgColor={themeColour}>
//                 Value
//               </StyledTableCellHistory>
//               <StyledTableCellHistory bgColor={themeColour}>
//                 Unit
//               </StyledTableCellHistory>
//             </StyledTableRowHistory>
//           </TableHead>
//           <TableBody>
//             {data.map((panel, panelIndex) =>
//               panel.tests.map((test, testIndex) => (
//                 <StyledTableRowHistory key={`${panelIndex}_${testIndex}`}>
//                   <StyledTableCellHistory>
//                     {testIndex === 0 ? panel.panel_name : ""}
//                   </StyledTableCellHistory>
//                   <StyledTableCellHistory>{test.test}</StyledTableCellHistory>
//                   <StyledTableCellHistory>
//                     {test.value || "-"}
//                   </StyledTableCellHistory>
//                   <StyledTableCellHistory>
//                     {test.unit || "-"}
//                   </StyledTableCellHistory>
//                 </StyledTableRowHistory>
//               ))
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </Grid>
//   );
// };

export const AdultVaccinationData = ({ data }) => {
  const brandingData = useContext(BrandingContext);
  const brandingItem = brandingData?.find(
    (item) => item.name === "branding_statements"
  );
  const themeColour = brandingItem?.content?.themeColour || "#21cdc0";

  const isHistoryObject = data && !Array.isArray(data) && (data.prev || data.new);
  const vaccinations = isHistoryObject
    ? [...(data.prev || []), ...(data.new || [])]
    : (data || []);

  return (
    <>
      {vaccinations && vaccinations.length > 0 && (
        <Grid item xs={11}>
          <TableContainer
            component={Paper}
            sx={{ border: `1px solid ${themeColour}`, mb: 2 }}
          >
            <Table>
              <TableHead>
                <StyledTableRowHistory>
                  <StyledTableCellHistoryForPreview>
                    Vaccine Name
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Dose
                  </StyledTableCellHistoryForPreview>
                  <StyledTableCellHistoryForPreview>
                    Date of Administration
                  </StyledTableCellHistoryForPreview>
                </StyledTableRowHistory>
              </TableHead>
              <TableBody>
                {vaccinations.map((row, rowIndex) => (
                  <StyledTableRowHistory key={rowIndex}>
                    <StyledTableCellHistory>
                      {row.vaccine_name}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row.dose || "-"}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      <DisplayDate value={row.date_of_administration} />
                    </StyledTableCellHistory>
                  </StyledTableRowHistory>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      )}
    </>
  );
};

export const InitialObservationData = ({ data }) => {
  const brandingData = useContext(BrandingContext);
  const brandingItem = brandingData?.find(
    (item) => item.name === "branding_statements"
  );
  const themeColour = brandingItem?.content?.themeColour || "#21cdc0";

  const hasObservationValue = (value) => {
    if (value === 0 || value === "0") return true;
    if (value === undefined || value === null) return false;
    return String(value).trim().length > 0;
  };

  const filteredPanels = Array.isArray(data)
    ? data
      .map((panel) => ({
        ...panel,
        tests: (panel?.tests || []).filter((test) =>
          hasObservationValue(test?.value)
        ),
      }))
      .filter((panel) => panel.tests.length > 0)
    : [];

  if (filteredPanels.length === 0) return null;

  return (
    <Grid item xs={12} sm={11}>
      <Typography
        sx={{
          fontWeight: "bold",
          fontSize: "1rem",
          mt: 2,
          mb: 1,
        }}
        component="div"
      >
        Initial Observation
      </Typography>

      <TableContainer
        component={Paper}
        sx={{ border: `1px solid ${themeColour}`, mb: 2 }}
      >
        <Table>
          <TableHead>
            <StyledTableRowHistory>
              <StyledTableCellHistoryForPreview>
                Panel
              </StyledTableCellHistoryForPreview>
              <StyledTableCellHistoryForPreview>
                Test Name
              </StyledTableCellHistoryForPreview>
              <StyledTableCellHistoryForPreview>
                Value
              </StyledTableCellHistoryForPreview>
              <StyledTableCellHistoryForPreview>
                Unit
              </StyledTableCellHistoryForPreview>
            </StyledTableRowHistory>
          </TableHead>
          <TableBody>
            {filteredPanels.map((panel, panelIndex) =>
              panel.tests.map((test, testIndex) => (
                <StyledTableRowHistory key={`${panelIndex}_${testIndex}`}>
                  <StyledTableCellHistory>
                    {testIndex === 0 ? panel.panel_name : ""}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>{test.test}</StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {test.value || "-"}
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    {test.unit || "-"}
                  </StyledTableCellHistory>
                </StyledTableRowHistory>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};
